<template>
  <div id="pmsfinder">
    <home :defaultServiceType="types"></home>
  </div>
</template>

<script>
// import '@siteminder/chameleon-styles'
import Home from '@/views/Home.vue'

export default {
  name: 'App',

  components: {
    Home
  },
  data () {
    return {
      types: this.hasClass()
    }
  },
  methods: {
    hasClass() {
      const element = document.querySelector('#pmsfinder')
      const classList = element.classList
      let serviceTypes = []
      classList.forEach(cls => {
        serviceTypes.push(cls)
        console.log('serviceTypes:::', serviceTypes)
      });
      return serviceTypes
    }
  }
}

</script>

<style lang="scss">

</style>
